
import moment from "moment";
import { isEmpty } from '@/pages/intelligence/utils/commonUtils';

/**获取combine游戏对应游戏icon类型 */
export const getCombineEntityType = (entitytypeValue: string, item: any = {}) => {
  const entityType = entitytypeValue?.toLowerCase();
  if (isEmpty(item) || entityType !== 'combine') {
    return entitytypeValue;
  } else {
    if (item.pc_id === '' && item.console_id !== '') {
      return 'console';
    }
    if (item.pc_id !== '' && item.console_id === '') {
      return 'pc';
    }
    return 'combine';
  }
}

/**获取combine游戏对应游戏头像类型 */
export const getCombineImageEntityType = (entitytypeValue: string, item: any = {}) => {
  const entityType = entitytypeValue?.toLowerCase();
  if (isEmpty(item) || entityType !== 'combine') {
    return entitytypeValue;
  } else {
    if (item.pc_id !== '') {
      return 'pc';
    } else if (item.console_id !== '') {
      return 'console';
    } else {
      return 'combine';
    }
  }
}

/**获取平台对应的图标 */
export const getEntityTypeIcon = (entitytype: string) => {
  const entityType = entitytype?.toLowerCase();
  switch (entityType) {
    case 'pc':
      return 'monitor';
    case 'console':
      return 'game';
    case 'company':
      return 'folded-graph';
    case 'combine':
      return 'pc-console-combine';
    case 'mobile':
    default:
      return 'other-icon';
  }
}

/**获取游戏类型对应的图标 */
// export const getGameTypeIcon = (entitytype: string) => {
//   const entityType = entitytype?.toLowerCase();
//   switch (entityType) {
//     case 'pc':
//       return 'monitor';
//     case 'console':
//       return 'merit';
//     case 'company':
//       return 'folded-graph';
//     case 'combine':
//       return 'pc-console-combine';
//     case 'mobile':
//     default:
//       return 'book-m';
//   }
// }

/**获取游戏类型对应的图片大小尺寸 */
export const getGameTypeImgType = (entitytype: string) => {
  const entityType = entitytype?.toLowerCase();
  switch (entityType) {
    case 'pc':
      return 'card-box-img1';
    case 'console':
      return 'card-box-img2';
    case 'company':
    case 'mobile':
    default:
      return 'card-box-img';
  }
}

/**
 * 根据某个日期字段，获取前一个月的数据
 * @param arr 源数组
 * @param key 根据此 key 为规则
 * @returns 当前日期前一个月的数据
 */
export const transTableAsNewTabCBTothers = (
  arr: Array<any>,
  key = 'release_time',
  keyC = 'game_phase',
) => {
  const lastMonthTime = moment().subtract(1, 'months').valueOf()
  const currentMonthTime = moment().valueOf()
  if (!Array.isArray(arr)) {
    return [];
  }
  return arr.map(item => {
    const value = item[key] || undefined //找到release_time值

    // 若没有该值则不能作为获取条件
    if (!value) return item

    const time = moment(item[key])?.valueOf()

    //在release_time不为空的情况， 如果game_phase === 'CBT， && ... ， 则为cbtTag = true
    const flagC = item[keyC] == 'CBT' && currentMonthTime <= (time + 7 * 24 * 60 * 60 * 1000)
    //在release_time不为空的情况， 如果game_phase !== 'CBT， && ... ， 则为newTag = true
    const flag = item[keyC] != 'CBT' && time >= lastMonthTime && time <= currentMonthTime
    //并将字段处理一下给组装成表格数据返回
    if (flagC) {
      item.cbtTag = true;
      return item
    }
    if (flag) {
      item.newTag = true;
      return item
    }
    return item
    // return flag
  })
}

// B，M，K保留2位小数, 坐标轴的话不显示小数,所以加paseInt处理
export function mathFormat(data: any, showZero = false, min = 1000) {
  let unit = 'k';
  let value: any = Math.abs(data);
  if (showZero && !data) return 0;
  if (!data || isNaN(data)) return '-';
  let isNegativeStr = data < 0 ? '-' : '';
  // 最外面的 parseFloat用于去除末尾无效的零
  if (value < 1000000 && value >= 1000) {
    unit = 'K';
    value = parseFloat((parseFloat(value) / 1000).toFixed(2));
  } else if (value >= 1000000 && value < 1000000000) {
    unit = 'M';
    value = parseFloat((parseFloat(value) / 1000000).toFixed(2));
  } else if (value >= 1000000000) {
    unit = 'B';
    value = parseFloat((parseFloat(value) / 1000000000).toFixed(2));
  } else if (value < min) {
    unit = '';
    value = parseInt(data);
  } else {
    unit = '';
    value = parseFloat((parseFloat(value)).toFixed(2));
  }
  // return isNegativeStr + Math.abs(value) + unit;

  // Math.abs会去掉末尾的0，为保证数据格式统一，所以不用
  if (value < 0) value = -value;
  return isNegativeStr + value + unit;
}

export function formatNum(num: any, isToFixed = false, fixedNumber = 2) {
  let s = new String(num)
  let arr = s.split('.')
  if (arr[0]?.length > 3) { // 大于一千
    // 将数字转换为字符串，进行三位分割
    let _num = ('' + arr[0]).replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    // 整数
    let x: any = new Number(_num.split(',')[0]);
    // 小数
    let x2: any = _num.split(',')[1];
    let _arr = ['K', 'M', 'B', 'T']
    if (!isToFixed) {
      return (Math.round(new Number(x + ('.' + x2)) * 100) / 100 + '' + _arr[_num.split(',')?.length - 2])
    } else {
      return ((Math.round(new Number(x + ('.' + x2)) * 100) / 100).toFixed(fixedNumber) + '' + _arr[_num.split(',')?.length - 2])
    }
  } else if (arr[1]) { // 小于一千且有小数
    if (!isToFixed) {
      return Math.round(new Number(arr[0] + '.' + arr[1]) * 100) / 100
    } else {
      return (Math.round(new Number(arr[0] + '.' + arr[1]) * 100) / 100).toFixed(fixedNumber)
    }
  } else { // 小于一千没有小数
    return num
  }
}


//数据格式处理  -- 243K， 0展示0   空或-展示 -
export const valueFormat = (value: any) => {
  if (isNaN(value) || value === '' || value === null || value === '-') {
    return '-'
  }
  if (value === 0 || value === '0') {
    return 0
  }
  return mathFormat(value);
}
//数据格式处理  -- 10%， 0展示0%   空或-展示 -
export const growthFormat = (value: any, isPoain: boolean/**是否是小数点，是则前端转为百分数 */) => {
  let newVal = value;  //newVal用于展示数值，没有正负符号
  let typeValue = value;//typeValue用地判断类型，有正负符号
  if (newVal === '' || newVal === null || newVal === '-' || newVal === undefined) {
    return { value: '-', type: '' }
  }
  if (isPoain) {
    //newVal用于展示数值，没有正负符号
    newVal = Math.round(Math.abs(newVal * 100))
    //typeValue用于判断类型，有正负符号
    typeValue = Math.round(typeValue * 100)
  } else {
    newVal = Math.abs(newVal)
    typeValue = value
  }
  //0.0025 为0
  if (newVal === 0 || newVal === '0') {
    return { value: '0% -', type: '' }
  }
  return {
    value: newVal + '%',
    type: typeValue < 0 ? 'down' : typeValue > 0 ? 'up' : ''
  }

}
//时间格式处理
export const timeFormat = (val: string | moment.Moment) => {
  if (!val) {
    return ''
  }
  const _date = moment(val).format('yyyy-MM-DD')
  if (_date === 'Invalid date') {
    return ''
  }
  return _date;
}

// home折线图排序
export const sortLineTooltipValue = (params: any, inverse = false, dataList: any[]) => {
  const valueArr: any[] = [];
  const undeArr: any[] = [];
  params?.forEach((item: any) => {
    if (item?.value) {
      valueArr.push(item)
    } else {
      undeArr.push(item)
    }
  })
  const sortArr = valueArr.sort((a, b) => {
    return inverse ? (a?.value - b?.value) : (b?.value - a?.value)
  })
  let newArr = [...sortArr, ...undeArr];
  if (Array.isArray(dataList) && dataList?.length > 0) {
    let hasPerList: any = [];
    let noPerList: any = [];
    newArr?.forEach((item: any) => {
      const tempObj: any = dataList?.find((itemSub: any) => {
        return itemSub?.game === item.seriesName
      }) || {};
      if (tempObj && tempObj?.has_permission) {
        hasPerList.push(item);
      } else {
        noPerList.push(item);
      }
    });
    return [...hasPerList, ...noPerList];
  } else {
    return newArr;
  }
}

// 权限游戏排序
export const sortPermissionList = (list: any[]) => {
  if (Array.isArray(list) && list?.length > 0) {
    let hasPerList: any = [];
    let noPerList: any = [];

    list?.forEach((item: any) => {
      if (item.has_permission) {
        hasPerList.push(item);
      } else {
        noPerList.push(item);
      }
    });
    return [...hasPerList, ...noPerList];
  } else {
    return list;
  }
}
export const setName = (str:string)=>{
  if(!str) return ''
  const nameStr = str.split('(')[0]
  return nameStr
}
